import React, { useState } from "react";
import Viewer from "react-viewer";
import { AWS_URL, MEDIA_DOWNLOAD_URL } from "../../../configs/config";
import { forceDownload } from "../../../utils/photo.utils";
import { Document, Page, pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const DisplayAttachmentsModal = ({ attachments = [], closeModal }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div>
      {attachments
        .filter(a => a)
        .map(file => {
          const fileExtension = typeof file === "string" ? file.split(".")[1] : file.Key.split(".")[1];
          const urlFile = `https://backend-dev.efficiencesell.fr/api/media/get/${
            typeof file === "string" ? file : file.Key
          }`;

          if (fileExtension === "pdf")
            return (
              <div className="p-2 pdf-viewer">
                <Document file={urlFile}>
                  <Page pageNumber={1} />
                </Document>
              </div>
            );
          return (
            <div className="w-full my-10 flex justify-center">
              <div className="p-phototheque-item-container">
                <div className="p-phototheque-item-photo-container">
                  <img
                    onClick={() => {
                      setIsVisible(true);
                    }}
                    class="photoswipe-gallery"
                    className="p-phototheque-item-photo"
                    src={urlFile}
                  />
                  <Viewer
                    visible={isVisible}
                    drag={true}
                    noClose={false}
                    rotatable={true}
                    scalable={true}
                    downloadable={false}
                    onMaskClick={() => {
                      setIsVisible(false);
                    }}
                    onClose={() => {
                      setIsVisible(false);
                    }}
                    customToolbar={toolbars => {
                      return toolbars.concat([
                        {
                          key: "download_custom",
                          render: (
                            <li className="react-viewer-btn" data-key="download">
                              <i className="react-viewer-icon react-viewer-icon-download" />
                            </li>
                          ),
                          onClick: activeImage => {
                            forceDownload(activeImage.downloadUrl, activeImage.name + ".jpg");
                          }
                        }
                      ]);
                    }}
                    images={[
                      {
                        src: urlFile,
                        alt: "",
                        downloadUrl: urlFile,
                        name: typeof file === "string" ? file : `${file.Key}`
                      }
                    ]}
                  />
                </div>
              </div>
            </div>
          );
        })}

      {closeModal && (
        <div
          className="flex justify-center cursor-pointer px-6 py-2 mx-10 my-10 leading-5 rounded-full bg-green-400 text-white"
          onClick={closeModal}
        >
          Fermer
        </div>
      )}
    </div>
  );
};

export default DisplayAttachmentsModal;



// WEBPACK FOOTER //
// src/modules/presence/components/DisplayAttachments.modal.js